module.exports = __webpack_public_path__ + "img/used-car-gt-r-point.b7d271c3.jpg";